<template>
  <EventListContainer :loading />
</template>

<script setup>
import { useHead, useNuxtApp, useRoute } from '#imports';
import { computed, onMounted, watch } from 'vue';
import { getMetadataAndTags } from '../../helpers/metadata';
import { clientWorkWindowEvent } from '../../helpers/event-dispatch-helpers.js';
import EventListContainer from '../../components/events/EventListContainer';
import { useEventsStore } from '../../stores/eventsStore.js';
import { useMainStore } from '../../stores/mainStore.js';

const route = useRoute();
const eventsStore = useEventsStore();
const mainStore = useMainStore();
const metaDataInfo = getMetadataAndTags(mainStore.settings.metadata, 'events', 'Events');
const loading = computed(() => eventsStore.isLoading);
const $axios = useNuxtApp().$axios;

useHead({
  ...metaDataInfo.metaTitle,
  meta: metaDataInfo.metaTags,
});

onMounted(async () => {
  eventsStore.filterView(route.query.view);
  await eventsStore.buildEventComponentData({
    $axios,
  });

  clientWorkWindowEvent('events-loaded');
});

watch(
  () => route.query,
  async () => {
    eventsStore.filterView(route.query.view);
    await eventsStore.buildEventComponentData({
      $axios,
    });
    clientWorkWindowEvent('events-loaded');
  },
);
</script>
